/**
 * @module accountsLiability
 * @description A list of accountsLiability
 */
export const accountsLiability = [
	{
		objectNumber: 53003,
		name: 'Writeoff Account',
	},
	{
		objectNumber: 53001,
		name: 'Tax ',
	},
	{
		objectNumber: 53002,
		name: 'Payroll Taxes',
	},
]
